export default __webpack_public_path__ + "static/media/ny-cityguide-03.dea87113.jpg";